import { MENU_LEAF_PERMISSION_CODES } from './menuPermissionSpec';

/**
 * Agrège les permission_code pour un utilisateur (toutes ses affectations actives).
 * Administrateur : tous les codes menu nav.* (même si absents de role_permissions en base).
 */
export async function fetchEffectivePermissionCodes(supabase, userId) {
  if (!supabase || !userId) return [];

  const { data: assignments, error: aErr } = await supabase
    .from('user_role_assignments')
    .select('role_id, user_roles(role_type)')
    .eq('user_id', userId)
    .eq('is_active', true);

  if (aErr) throw aErr;

  const roleTypes = (assignments || [])
    .map((a) => a?.user_roles?.role_type)
    .filter((t) => typeof t === 'string' && t.trim());

  if (roleTypes.includes('administrator')) {
    return [...MENU_LEAF_PERMISSION_CODES];
  }

  const AGENT_MENU_CODES = ['nav.dashboard', 'nav.patients', 'nav.cases'];
  if (roleTypes.includes('agent_administratif')) {
    const roleIds = [...new Set((assignments || []).map((a) => a.role_id).filter(Boolean))];
    const codes = new Set(AGENT_MENU_CODES);
    if (roleIds.length > 0) {
      const { data: rows, error: rpErr } = await supabase
        .from('role_permissions')
        .select('permission:permissions(permission_code)')
        .in('role_id', roleIds);
      if (!rpErr) {
        for (const row of rows || []) {
          const c = row?.permission?.permission_code;
          if (typeof c === 'string' && c.trim()) codes.add(c.trim());
        }
      }
    }
    return [...codes];
  }

  const roleIds = [...new Set((assignments || []).map((a) => a.role_id).filter(Boolean))];
  if (roleIds.length === 0) return [];

  const { data: rows, error: rpErr } = await supabase
    .from('role_permissions')
    .select('permission:permissions(permission_code)')
    .in('role_id', roleIds);

  if (rpErr) throw rpErr;

  const codes = new Set();
  for (const row of rows || []) {
    const c = row?.permission?.permission_code;
    if (typeof c === 'string' && c.trim()) codes.add(c.trim());
  }
  return [...codes];
}
